import React, { useContext, useEffect } from "react";
import { TargetsContext } from "../../contexts";
import { Test } from "./Test.js";
import useAds from "../../hooks/UseAds";
import { Link } from "react-router-dom";
import { Stats } from "./Stats";
import { Button } from "react-bootstrap";

export const Tests = () => {
  const targets = useContext(TargetsContext);

  useAds();

  /** Function: Map test data to list.
   */
  const mapper = () => {
    var ar = targets.map((item, index) => (
      <div key={index} className='my-5 '>
        <Test key={index} index={index} location={"xxx"} show={true} />
      </div>
    ));

    return ar.reverse();
  };

  return (
    <>
      <div className='text-start my-4'>
        <div className='d-flex justify-content-center my-5'>
          <Link to={`/global-testing`}>
            <Button id='run-tests-again' color='primary' size='lg'>
              Run Tests Again <i className='bi bi-arrow-right'></i>
            </Button>
          </Link>
        </div>
      </div>
      <Stats className='my-4'></Stats>
      <div>{mapper() ?? ""}</div>
    </>
  );
};
